const NotificationSettings = () => {
  return null;
};

export default NotificationSettings;
